import { CompanyRegistrationPeriodDTO } from '@iota/iota-management-portal-v4-client';
import { createAction, props } from '@ngrx/store';
import { AttributeListResult } from 'src/app/shared/components/attribute-list/attribute-list.component';

export enum RegistrationPeriodActionTypes {
    LoadRegistrationPeriods = '[RegistrationPeriod] LoadRegistrationPeriods',
    LoadRegistrationPeriodsSuccess = '[RegistrationPeriod] LoadRegistrationPeriodsSuccess',
    LoadRegistrationPeriodsFailure = '[RegistrationPeriod] LoadRegistrationPeriodsFailure',

    ReloadRegistrationPeriod = '[RegistrationPeriod] ReloadRegistrationPeriod',
    ReloadRegistrationPeriodSuccess = '[RegistrationPeriod] ReloadRegistrationPeriodSuccess',
    ReloadRegistrationPeriodFailure = '[RegistrationPeriod] ReloadRegistrationPeriodFailure',

    RegistrationPeriodActionFailure = '[RegistrationPeriod] RegistrationPeriodActionFailure',

    UpsertRegistrationPeriod = '[RegistrationPeriod] UpsertRegistrationPeriod',
    CreateRegistrationPeriodSuccess = '[RegistrationPeriod] CreateRegistrationPeriodSuccess',

    AddUpdateRemoveRegistrationPeriodAttributes = '[RegistrationPeriod] AddUpdateRemoveRegistrationPeriodAttributes'
}

export const LoadRegistrationPeriodsThatUseProduct = createAction(
    '[RegistrationPeriod] LoadRegistrationPeriodsThatUseProduct',
    props<{ productId: string }>()
);
export const LoadRegistrationPeriodsThatUseProductSuccess = createAction(
    '[RegistrationPeriod] LoadRegistrationPeriodsThatUseProductSuccess',
    props<{ registrationPeriods: CompanyRegistrationPeriodDTO[]; productId: string }>()
);

export const AddUpdateRemoveRegistrationPeriodAttributes = createAction(
    RegistrationPeriodActionTypes.AddUpdateRemoveRegistrationPeriodAttributes,
    props<{
        attributeResult: AttributeListResult;
        registrationPeriodId: string;
    }>()
);

export const ReloadRegistrationPeriod = createAction(
    RegistrationPeriodActionTypes.ReloadRegistrationPeriod,
    props<{ registrationPeriodId: string }>()
);
export const ReloadRegistrationPeriodSuccess = createAction(
    RegistrationPeriodActionTypes.ReloadRegistrationPeriodSuccess,
    props<{ registrationPeriod: CompanyRegistrationPeriodDTO }>()
);
export const ReloadRegistrationPeriodFailure = createAction(
    RegistrationPeriodActionTypes.ReloadRegistrationPeriodFailure,
    props<{ error: any }>()
);

export const LoadRegistrationPeriods = createAction(RegistrationPeriodActionTypes.LoadRegistrationPeriods, props<{ companyId: string }>());
export const LoadRegistrationPeriodsSuccess = createAction(
    RegistrationPeriodActionTypes.LoadRegistrationPeriodsSuccess,
    props<{ registrationPeriods: CompanyRegistrationPeriodDTO[]; companyId: string }>()
);
export const LoadRegistrationPeriodsFailure = createAction(
    RegistrationPeriodActionTypes.LoadRegistrationPeriodsFailure,
    props<{ error: any }>()
);

export const RegistrationPeriodActionFailure = createAction(
    RegistrationPeriodActionTypes.RegistrationPeriodActionFailure,
    props<{ error: any }>()
);

export const UpsertRegistrationPeriod = createAction(
    RegistrationPeriodActionTypes.UpsertRegistrationPeriod,
    props<{ registrationPeriod: CompanyRegistrationPeriodDTO }>()
);

export const CreateRegistrationPeriodSuccess = createAction(
    RegistrationPeriodActionTypes.CreateRegistrationPeriodSuccess,
    props<{ registrationPeriod: CompanyRegistrationPeriodDTO }>()
);
